module.exports = __webpack_public_path__ + "img/flowerS.13fe192b.png";